module.exports = __webpack_public_path__ + "static/media/landing-bg-old.96e11409.png";